import { Link } from "react-router-dom";
import { Button } from "../components/ui/button";

export default function NotFound() {
  return (
    <div className="min-h-[60vh] flex items-center justify-center px-6" data-testid="notfound-page">
      <div className="text-center max-w-md space-y-6">
        <div className="font-serif text-8xl text-terracotta font-light">404</div>
        <h1 className="font-serif text-3xl text-forest">This page wandered off.</h1>
        <p className="text-ink/70">Probably chasing a squirrel. Let's get you back home.</p>
        <Link to="/"><Button className="bg-terracotta hover:bg-terracotta-deep text-bone rounded-full h-12 px-8 font-semibold">Take me home</Button></Link>
      </div>
    </div>
  );
}
